module.exports = "varying vec3 vPos;\n\nvoid main() {\n\tvPos = position;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/tree-vert.glsl
// module id = 9
// module chunks = 0